module.exports = __webpack_public_path__ + "static/media/ClientImg.15d9b612.png";